import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function PlusCircleFill({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M2.1001 12C2.1001 6.52233 6.53263 2.09998 12.0001 2.09998C17.4682 2.09998 21.9001 6.53192 21.9001 12C21.9001 17.468 17.4682 21.9 12.0001 21.9C6.52245 21.9 2.1001 17.4674 2.1001 12ZM12.9 8C12.9 7.50294 12.4971 7.1 12 7.1C11.5029 7.1 11.1 7.50294 11.1 8V11.1H8C7.50294 11.1 7.1 11.5029 7.1 12C7.1 12.4971 7.50294 12.9 8 12.9H11.1V16C11.1 16.4971 11.5029 16.9 12 16.9C12.4971 16.9 12.9 16.4971 12.9 16V12.9H16C16.4971 12.9 16.9 12.4971 16.9 12C16.9 11.5029 16.4971 11.1 16 11.1H12.9V8Z" fill="currentColor" /></Svg>;
}
export default PlusCircleFill;